export const BULK_SCENARIO_GROUP_REQUEST = 'BULK_SCENARIO_GROUP_REQUEST';
export const BULK_SCENARIO_GROUP_SUCCESS = 'BULK_SCENARIO_GROUP_SUCCESS';
export const BULK_SCENARIO_GROUP_ERROR = 'BULK_SCENARIO_GROUP_ERROR';
export const BULK_SCENARIO_GROUP_UPDATE_TASK = 'BULK_SCENARIO_GROUP_UPDATE_TASK';